import { useTranslation } from 'react-i18next';
import type { TableLabels } from '@konnecta/generic-table';

export const useAppTableLabels = (): TableLabels => {
  const { t } = useTranslation();
  return {
    update: t('table-update'),
    delete: t('table-delete'),
    rowActions: t('table-row-actions'),
    actions: t('table-actions'),
    search: t('table-search'),
    loading: t('table-loading'),
    noData: t('table-no-data'),
    export: t('table-export'),
    resetList: t('table-reset-list'),
    clearAdvancedFilters: t('table-clear-filters'),
    apply: t('table-apply'),
    clearSelection: t('table-clear-selection'),
    rowsSelectedOne: t('table-rows-selected-one'),
    rowsSelectedOther: t('table-rows-selected-other'),
    selectAllPages: t('table-select-all-pages'),
    selectAllRecords: t('table-select-all-records'),
    selectedCount: t('table-selected-count'),
    selectedAllResults: t('table-selected-all-results'),
    excludedCount: t('table-excluded-count'),
    selectAllResults: t('table-select-all-results'),
    clearSelectionFull: t('table-clear-selection-full'),
  };
};
